import { useDispatch } from 'store/hooks';
import { useCallback } from 'react';
import {
    FilterState,
    GridFiltersState,
} from 'widgets/store/grid/filters/FilterState';
import { buildUpdateWidgetConfigurationActionCreator } from 'widgets/store/configuration/actions';
import { useWidgetContext } from 'widgets/WidgetContext';
import { WidgetType } from 'widgets/WidgetType';

export const buildUpdateBlotterFilterAction = <TColumnId extends string>(
    widgetType: WidgetType,
    widgetKey: string,
    filters: FilterState<TColumnId>[]
) => {
    const actionCreator =
        buildUpdateWidgetConfigurationActionCreator<
            GridFiltersState<TColumnId>
        >(widgetType);

    return actionCreator(widgetKey, { filters });
};

export const useDispatchUpdateFilters = <TColumnId extends string>() => {
    const { widgetType, widgetKey } = useWidgetContext();

    const dispatch = useDispatch();

    return useCallback(
        (filters: FilterState<TColumnId>[]) => {
            const action = buildUpdateBlotterFilterAction(
                widgetType,
                widgetKey,
                filters
            );
            dispatch(action);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [widgetType, widgetKey]
    );
};
